import axios from 'axios'
import { INSTANCE, INSTANCELIST, SERVER } from './API'

const OFFERS_EXPORT_MAX_ROWS = 2000

export { OFFERS_EXPORT_MAX_ROWS }

export const getOffers = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token, tabFilter } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/offers/details',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify(filter),
                ...tabFilter,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getOffersServices = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token, tabFilter } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/offers/services',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify(filter),
                ...tabFilter,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getSimpleOffers = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token, tabFilter } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/offers',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify(filter),
                ...tabFilter,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const CreateAnOffer = (form, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/offers',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const DeleteOffer = (offerId, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/offers/${offerId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: {
                status: 'discontinued',
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getSingleOffer = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { offerId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/offers/${offerId}/details`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const EditOffer = (form, token, offerId) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/offers/${offerId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const getOfferLottery = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { offerId, channel, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/lottery-draws/details`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                filter: {
                    offer: offerId,
                    channel,
                },
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getOfferAnalytics = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { offerId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/offers/${offerId}/analytics`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getOfferRelatedOrders = (offerId, token) =>
    new Promise((resolve, reject) => {

        INSTANCELIST({
            method: 'get',
            url: `/orders/details?offer=${offerId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const exportOffersExcel = ({ sort, filter, tabFilter, token }) =>
    new Promise((resolve, reject) => {
        axios({
            method: 'get',
            baseURL: SERVER.baseURL,
            url: '/offers/exports',
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                filter: JSON.stringify(filter),
                ...(tabFilter || {}),
            },
        })
            .then((response) => {
                resolve({
                    blob: response.data,
                    truncated: response.headers['x-export-truncated'] === 'true',
                    total: Number(response.headers['x-export-total'] || 0),
                })
            })
            .catch(async (error) => {
                if (
                    error.response?.status === 401 ||
                    error.response?.status === 403
                ) {
                    localStorage.clear()
                    window.location.href = '/'
                    return
                }

                if (error.response?.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text()
                        const parsed = JSON.parse(text)
                        error.exportMessage = parsed.message
                    } catch (parseError) {
                        // ignore JSON parse errors on blob responses
                    }
                }

                reject(error)
            })
    })
